/* globals angular */
import findDom from '~/modules/findReplace/find-dom'
// eslint-disable-next-line @typescript-eslint/no-use-before-define
export default ['$compile', '$sce', '$rootScope', directive]

export const constants = {
  WORDCOUNT: '@CONTENT_EDITABLE_BIND/WORDCOUNT',
}

function directive($compile, $sce, $rootScope) {
  return {
    restrict: 'A',
    require: '?ngModel',
    scope: {
      featureObj: '=',
      orgIndex: '<',
    },
    controller: [
      '$scope',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      function ($scope) {
        // todo: add client config somehow
        // this probably comes from settings service passed down from story component
      },
    ],
    link: ($scope, element, attrs, ngModel) => {
      const fd = findDom(document)

      if (!ngModel) {
        return // do nothing if no ng-model
      }

      const handleEmpty = () => {
        const html = element.html()
        const temp = angular.element('<div></div>').html(html)
        const hasText = temp.text().trim().length
        if (!hasText) {
          element.addClass('br-empty')
        }
      }

      // Specify how UI should be updated
      ngModel.$render = () => {
        element.html($sce.getTrustedHtml(ngModel.$viewValue || ''))
        handleEmpty()
      }

      element.on('blur change update', () => {
        $scope.$evalAsync(() => {
          const html = element.html()
          ngModel.$setViewValue(html)
          handleEmpty()
        })
      })

      element.on('focus', () => {
        element
          .removeClass('br-empty')
          .closest('[content-element]')
          .addClass('feature-focused')
          .trigger('focus') // I do not think it is actually triggering like it should be
          .siblings('.feature-focused')
          .removeClass('feature-focused')
        angular.element('.feature-focused').triggerHandler('focus')
      })

      // initial value of html needs to be cached
      const unsubscribeFindRepace = $rootScope.$on(
        'FIND_AND_REPLACE',
        (sender, action) => {
          if (action.type === 'FIND') {
            fd.removeMarks(element)
            const txt = action.toFind
            const norm = fd.toTextModel(element.innerHTML)
            const found = fd.findWord(txt, norm.content, norm.attrs)
            element.innerHTML = fd.toElems(found.content, found.attrs)
          }
          if (action.type === 'REPLACE') {
            // action.selections
          }
        }
      )

      // Since the blur code is not called, set dirty flag on elements
      // When save is called, we loop over dirty and update the models
      const unsubscribe = $rootScope.$on('BEFORE_SAVE', function (
        /* eslint-disable @typescript-eslint/no-unused-vars */
        evt,
        focusedElem
        /* eslint-enable @typescript-eslint/no-unused-vars */
      ) {
        const ele = element.closest('[content-element]')

        // 2e8f36ad0ad521f658013c6e915748294a9b85a2
        const anchorNode = document.getSelection().anchorNode
        if (angular.isDefined(anchorNode) && anchorNode !== null) {
          const isActive =
            document.getSelection().anchorNode.parentNode === ele.context
          if (ele.hasClass('dirty') || isActive) {
            ele.removeClass('dirty')
            ngModel.$setViewValue(element.html())
          } else if (element.is('td,th')) {
            ngModel.$setViewValue(element.html())
          }
        }
      })
      $scope.$on('$destroy', () => {
        unsubscribe()
        unsubscribeFindRepace()
      })
    },
  }
}
